export const BLOCKS_PERMISSION_QUERY_KEYS = {
  permissionsBase: ["blocks-permissions"] as const,
  allPermissions: ["blocks-permissions", "all"] as const,
  permissions: (role: string) => ["blocks-permissions", role] as const,
  organizations: ["organizations"] as const,
  udsPolicyMap: ["uds-policy-map"] as const,
} as const;
